import React from "react";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import SuccessArea from "../../components/SuccessArea/SuccessArea";
import InnerServicesArea from "../../components/ServicesArea/InnerServicesArea";
import InnerServiceAre from "../../components/ServicesArea/innerServiceAre";
import DocumentMeta from "react-document-meta";
import { Helmet } from "react-helmet";

function ServicePage() {
  return (
    <>
      <Helmet>
        <title>Services – The Digital Creative Designs USA</title>
        <meta
          name="description"
          content="Discover The Digital Creative Designs's creative design. From branding to web design, we provide creative solutions to elevate your business. Contact us today to get started!"
        />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="author" content="The Digital Creative Designs" />
        <meta
          property="og:title"
          content="Services – The Digital Creative Designs USA"
        />
        <meta
          property="og:description"
          content="Discover The Digital Creative Designs's creative design. From branding to web design, we provide creative solutions to elevate your business. Contact us today to get started!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="The Digital Creative Designs US" />
        <meta
          property="og:url"
          content="https://thedigitalcreativedesigns.com/services"
        />
        <meta
          property="og:image"
          content="https://thedigitalcreativedesigns.com/img/logo1.png"
        />

        <link rel="canonical" href="https://thedigitalcreativedesigns.com/services" />
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title="Our Services"
          subtitle={"Services"}
          className={"pt-175 pb-140"}
        />
        <InnerServiceAre />
      </Layout>
    </>
  );
}

export default ServicePage;
